import { VariableInfo } from '@/lib/PlannerDTOs';

// Facets that support canary deployment. A variable is canary-eligible only
// when its assignBy facet is one of these values.
export const CANARY_ELIGIBLE_ASSIGN_BY = new Set(['pax', 'mex', 'dax']);

export const isCanaryEligible = (
  variable: VariableInfo | null | undefined,
): boolean => CANARY_ELIGIBLE_ASSIGN_BY.has(variable?.assignBy ?? '');
